export default "__VITE_ASSET__x3S5KB$O__"